import { render, staticRenderFns } from "./AdminIndex.vue?vue&type=template&id=f003bf06&scoped=true"
import script from "./AdminIndex.vue?vue&type=script&lang=js"
export * from "./AdminIndex.vue?vue&type=script&lang=js"
import style0 from "./AdminIndex.vue?vue&type=style&index=0&id=f003bf06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f003bf06",
  null
  
)

export default component.exports